import Axios from 'axios';
import { AssociationUrl } from "../../config/properties";

const updateInvitedSupplier = async (organizationId) => {
  let token;
  const cname = 'idToken';
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      token = c.substring(name.length, c.length);
    }
  }
  try {
    const response = await Axios.get(`${AssociationUrl}/updateSupplierData?orgId=${organizationId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    console.log("Update supplier data response:", response.data);
  } catch (error) {
    console.log("Update supplier error:", error);
  }
}

export default updateInvitedSupplier;



// WEBPACK FOOTER //
// ./src/components/Invitation/updateInvitedSupplier.jsx